import React from "react";
import { Link } from "react-router-dom";
import { Grid, Header, Message, Segment, Icon, Button } from "semantic-ui-react";
import { useSelector } from "react-redux";

import { isCompanyFeatureActive } from "utilities/dist/company/helpers";
import { CompanyFeatures } from "utilities/dist/company/constants";

import { InventoryHistoryComponent } from "./inventory-history.component";
import { InvoiceComponentSummarizedList } from "../../invoice/components/summarized-list";
import ProductSingleComponent from "../grid/single.component";

export const ProductViewContainer = ({ id }) => {
    const { product, isLoading, error } = useSelector(({ productView, auth }) => ({
        product: productView.products[id],
        isLoading: productView.isLoading[id],
        error: productView.errors[id],
        auth,
    }));

    const isCustomerInvoiceNumberingActive = useSelector(({ auth }) =>
        isCompanyFeatureActive(auth.user.company, CompanyFeatures.CUSTOMER_INVOICE_NUMBERING)
    );
    const isInventoryActive = useSelector(({ auth }) =>
        isCompanyFeatureActive(auth.user.company, CompanyFeatures.INVENTORY)
    );

    if (error) {
        return <Message negative header="Error loading product" content={error} />;
    }

    return (
        <Grid>
            {isLoading && !product ? (
                <Grid.Column computer={16}>
                    <Segment loading={isLoading} />
                </Grid.Column>
            ) : (
                product && (
                    <>
                        <Grid.Column computer={6} tablet={12} mobile={16}>
                            <ProductSingleComponent product={product} />
                            {isInventoryActive && (
                                <>
                                    <Header attached="top" as="h4">
                                        Inventory History
                                    </Header>
                                    <Segment attached>
                                        <InventoryHistoryComponent
                                            history={product.inventory?.inventoryHistory}
                                        />
                                    </Segment>
                                </>
                            )}
                        </Grid.Column>
                        <Grid.Column computer={8} tablet={16} mobile={16}>
                            {!product?.invoices?.length ? (
                                <Segment placeholder>
                                    <Header icon>
                                        <Icon name="newspaper outline" />
                                        You have never invoiced this product.
                                    </Header>
                                    <Button positive as={Link} to="/invoice/create">
                                        Create Invoice
                                    </Button>
                                </Segment>
                            ) : (
                                <>
                                    <Header attached="top" content="Invoice History" />
                                    <Segment attached>
                                        <InvoiceComponentSummarizedList
                                            invoices={product.invoices.sort(
                                                (prev, next) => next.id - prev.id
                                            )}
                                            isCustomerInvoiceNumberingActive={
                                                isCustomerInvoiceNumberingActive
                                            }
                                        />
                                    </Segment>
                                </>
                            )}
                        </Grid.Column>
                    </>
                )
            )}
        </Grid>
    );
};
